import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import BaseNode from './BaseNode';

const PromptNode = ({ data, onChange, onSubmit }) => {
  const changeHandler = onChange || data.onChange || (() => {});

  // Chat-bar-created prompt nodes: render as a minimal inline chip, no box
  if (data.isPrompt) {
    return (
      <div
        className="prompt-chip"
        onMouseDown={(e) => e.stopPropagation()}
        onWheel={(e) => e.stopPropagation()}
        title="Click to edit in chat bar"
      >
        <Handle type="target" position={Position.Top} style={{ backgroundColor: '#7c3aed' }} />
        <span className="prompt-chip-text">{data.content || ''}</span>
        <Handle type="source" position={Position.Bottom} style={{ backgroundColor: '#7c3aed' }} />
      </div>
    );
  }

  // Legacy / context-menu created prompt nodes: full box
  return (
    <BaseNode data={data} onChange={changeHandler} onSubmit={onSubmit}>
      <div
        className="prompt-node"
        onMouseDown={(e) => e.stopPropagation()}
        onWheel={(e) => e.stopPropagation()}
      >
        {data.content || ''}
      </div>
    </BaseNode>
  );
};

export default memo(PromptNode);
